import { useQuery } from "@tanstack/react-query";
import { Card } from "../../../components/card/card";
import { Template } from "../../../components/template/template";
import ActiveKeysService from "../../../services/web/active-keys-service";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";
import AgGridUtils from "../../../utils/aggrid-utils";

export default function ActiveKeys() {
    const { data, isLoading } = useQuery({
        queryKey: ['activeKeys'],
        queryFn: ActiveKeysService.list,
    });

    const referenceParameters = data?.referenceParameters ?? [];
    const referenceOccurrenceReasons = data?.referenceOccurrenceReasons ?? [];
    const interligationParameters = data?.interligationParameters ?? [];
    const despachoConfiguration = (data?.despachoConfiguration ?? []).flat();

    const colsReferenceParameters = useMemo(() => [
        { headerName: "Chave (key)", field: "key", flex: 2},
        { headerName: "Descrição", field: "description", tooltipField: "description", flex: 3 },
        { headerName: "Valor (value)", field: "value", tooltipField: "value" ,flex: 1 },
    ], []);

    const colsOccurrenceReasos = useMemo(() => [
        { headerName: "Naturezas (name)", field: "name" , flex: 3 },
        { headerName: "Pode ser interligada? (interligation)", headerTooltip: "Pode ser interligada? (interligation)" , field: "interligation", flex: 1, cellRenderer: (p) => (p.value ? "True" : "False") },
        { headerName:  "Liga o compartilhamento automaticamente? (auto_share)", headerTooltip: "Liga o compartilhamento automaticamente? (auto_share)" , field: "auto_share", flex: 1},
    ], []);

    const colsInterligation = useMemo(() => [
        { headerName: "Município (city)", field: "city", flex: 1 },
        { headerName: "Naturezas (reason)", field: "reason", flex: 2 },
        { headerName: "Regra (rule)", field: "rule", flex: 2 },
    ], []);

    const colsDespacho = useMemo(() => [
        { headerName: "Chave", field: "key", flex: 2 },
        { headerName: "Descrição", field: "description", flex: 3 },
        { headerName: "Valor", field: "value", flex: 1 },
    ], []);

    const gridCommon = useMemo(() => ({
        localeText: AgGridUtils.localization(),
        defaultColDef: { sortable: false, filter: false, resizable: false, editable: false, suppressMenu: true },
        rowSelection: undefined,
        suppressRowClickSelection: true,
        suppressCellFocus: true,
        enableCellTextSelection: true,
        suppressMovableColumns: true,
        suppressDragLeaveHidesColumns: true,
        suppressColumnMoveAnimation: true,
        suppressContextMenu: true,
        suppressRowHoverHighlight: true,
        suppressCellSelection: true,
        suppressMultiRangeSelection: true,
        enableRangeSelection: false,
        animateRows: false,
    }), []);

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Chaves ativas</Template.Title>
            </Template.Header>
            <Template.Body className="flex flex-col gap-2 pb-2.5">
                <Card>
                    <Card.Header>
                        <Card.Title>SentryView - refence.parameters</Card.Title>
                    </Card.Header>
                    <Card.Body>
                            <AgGridReact 
                                domLayout="autoHeight"
                                rowData={referenceParameters}
                                columnDefs={colsReferenceParameters}
                                gridOptions={gridCommon}
                                theme={AgGridUtils.generalTheme()}
                                enableBrowserTooltips={true}
                            />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header>
                        <Card.Title>reference.occurrence_reasons (Envio de ocorrências)</Card.Title>
                    </Card.Header>
                    <Card.Body>
                            <AgGridReact 
                                domLayout="autoHeight"
                                rowData={referenceOccurrenceReasons}
                                columnDefs={colsOccurrenceReasos}
                                gridOptions={gridCommon}
                                theme={AgGridUtils.generalTheme()}
                                enableBrowserTooltips={true}
                            />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header>
                        <Card.Title>interligation_parameters (Recebimento de ocorrências)</Card.Title>
                    </Card.Header>
                    <Card.Body>
                            <AgGridReact 
                                domLayout="autoHeight"
                                rowData={interligationParameters}
                                columnDefs={colsInterligation}
                                gridOptions={gridCommon}
                                theme={AgGridUtils.generalTheme()}
                            />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header>
                        <Card.Title>Despacho - tb_configuration</Card.Title>
                    </Card.Header>
                    <Card.Body>
                            <AgGridReact 
                                domLayout="autoHeight"
                                rowData={despachoConfiguration}
                                columnDefs={colsDespacho}
                                gridOptions={gridCommon}
                                theme={AgGridUtils.generalTheme()}
                            />
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}